<template>
    <div class="merge-field-broadcast-text-box-footer">
        <div class="button-row">
            <MergeFieldDropdown
                v-click-outside="() => isMergeFieldDropdownOpen = false"
                :is-open="isMergeFieldDropdownOpen"
                position="bottom-start"
                :merge-field-categories="mergeFieldCategories"
                @select="({ value }) => handleMergeFieldInsert(value)"
            >
                <template #action>
                    <DsIconButton
                        name="merge-field"
                        class="icon-button-merge-field"
                        @click="isMergeFieldDropdownOpen = !isMergeFieldDropdownOpen"
                    />
                </template>
            </MergeFieldDropdown>
        </div>
    </div>
</template>

<script>
import MergeFieldDropdown from '@/components/shared/MergeFieldDropdown.vue';

export default {

    components: {
        MergeFieldDropdown,
    },

    inject: ['$richTextBox'],

    props: {
        mergeFieldCategories: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            isMergeFieldDropdownOpen: false,
        };
    },

    methods: {
        handleMergeFieldInsert(val) {
            this.isMergeFieldDropdownOpen = false;

            this.$richTextBox.insertMergeField(val);
        },

        insertTemplate(template) {
            this.$richTextBox.insertTemplate(template);
        },
    },
};
</script>

<style lang="scss" scoped>
.merge-field-broadcast-text-box-footer {
    margin-bottom: 0;
    height: 100%;
}
.button-row {
    background-color: $color-ink-050;

    > * {
        margin: $spacing-050;
    }

    justify-content: flex-start;

    button:not(:last-child) {
        @include margin-end($spacing-100);
    }
}

</style>
